import { SvgIcon } from "@mui/material";

export default function MapIcon(props) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path
        d="M10.8751 6.15927L9.33072 6.79701L4 4.58826V17.1953L9.33072 19.404L14.6536 17.1953L20 19.4118V6.80479L18.487 6.17483"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M13 15L12 8L18 12.3448L15 12.8276L13 15Z" stroke="white" strokeLinejoin="round" fill="none" />
      <path
        d="M14.5 6.25C14.5 6.52614 14.7239 6.75 15 6.75C15.2761 6.75 15.5 6.52614 15.5 6.25L14.5 6.25ZM15.5 8.75C15.5 8.47386 15.2761 8.25 15 8.25C14.7239 8.25 14.5 8.47386 14.5 8.75L15.5 8.75ZM14.5 5L14.5 6.25L15.5 6.25L15.5 5L14.5 5ZM14.5 8.75L14.5 10L15.5 10L15.5 8.75L14.5 8.75Z"
        fill="white"
      />
      <path
        d="M14.5 14C14.5 14.2761 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.2761 15.5 14L14.5 14ZM15.5 16C15.5 15.7239 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.7239 14.5 16L15.5 16ZM14.5 13L14.5 14L15.5 14L15.5 13L14.5 13ZM14.5 16L14.5 17L15.5 17L15.5 16L14.5 16Z"
        fill="white"
      />
      <path
        d="M8.83325 8.07832C8.83325 8.35447 9.05711 8.57832 9.33325 8.57832C9.60939 8.57832 9.83325 8.35447 9.83325 8.07832H8.83325ZM9.83325 10.1175C9.83325 9.8414 9.60939 9.61754 9.33325 9.61754C9.05711 9.61754 8.83325 9.8414 8.83325 10.1175H9.83325ZM8.83325 12.1568C8.83325 12.4329 9.05711 12.6568 9.33325 12.6568C9.60939 12.6568 9.83325 12.4329 9.83325 12.1568H8.83325ZM9.83325 14.196C9.83325 13.9198 9.60939 13.696 9.33325 13.696C9.05711 13.696 8.83325 13.9198 8.83325 14.196H9.83325ZM8.83325 16.2352C8.83325 16.5113 9.05711 16.7352 9.33325 16.7352C9.60939 16.7352 9.83325 16.5113 9.83325 16.2352H8.83325ZM9.83325 18.2744C9.83325 17.9983 9.60939 17.7744 9.33325 17.7744C9.05711 17.7744 8.83325 17.9983 8.83325 18.2744H9.83325ZM8.83325 7.05872V8.07832H9.83325V7.05872H8.83325ZM8.83325 10.1175V12.1568H9.83325V10.1175H8.83325ZM8.83325 14.196V16.2352H9.83325V14.196H8.83325ZM8.83325 18.2744V19.294H9.83325V18.2744H8.83325Z"
        fill="white"
      />
    </SvgIcon>
  );
}
